<!--The content below is only a placeholder and can be replaced.-->
<router-outlet></router-outlet>
<span class="version-label">Version {{ version }}</span>